import { cdnTemplate } from 'cdnPreprocessor';

export default [
  '$interval',
  function productCarousel($interval) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        view: '=',
        product: '='
      },
      templateUrl: cdnTemplate('/product-carousel.html'),
      link: (scope, element) => {
        let currentIndex,
          $owl = $(element),
          imageLoadedCount = 0,
          owlInitialized = false;

        function updateScope(e) {
          currentIndex = e.item.index;
          if (e.item.index && e.item.index % 2 === 0) {
            scope.view = 'front';
          } else if(e.item.index) {
            scope.view = 'back';
          }
        };

        function initializeOwl() {
          $owl.owlCarousel({
              startPosition: (scope.view === 'back') ? 1 : 0,
              autoplay: false,
              loop: true,
              items: 1,
              dots: true,
              responsive: {
                0: { nav: false },
                768: { nav: true }
              }
            })
            .on('changed.owl.carousel', updateScope)
            .on('dragged.owl.carousel', updateScope);
          owlInitialized = true;
        }

        scope.$watch('view', (n, o) => {
          if (n == o) return;
          let to = (scope.view == 'front') ? 0 : 1;
          if (currentIndex % 2 != to) $owl.trigger('to.owl.carousel', [to]);
        });

        scope.$on('smart-img:loaded', function() {
          // count will be 1 when both images have loaded
          if (imageLoadedCount === 1 && !owlInitialized) {
            initializeOwl();
            imageLoadedCount = 0;
          } else if (imageLoadedCount === 1 && owlInitialized) {
            $owl.off('changed.owl.carousel', updateScope);
            $owl.off('dragged.owl.carousel', updateScope);
            $owl.trigger('destroy.owl.carousel');
            initializeOwl();
            imageLoadedCount = 0;
          } else {
            imageLoadedCount++;
          }
        });
      }
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/pages/store/product-carousel/product-carousel.dir.js